import { FieldOption } from "../../server/crm/api/models/forms";
import { IdXboxProgramDataResponse } from "../../server/crm/api/models/idXboxProgramModels";
import { OnboardingRootState } from "../reducers/rootReducer";
import { IdXboxProgramState, initialIdXboxProgramState } from "../reducers/idXboxProgramReducer";
import { getOnboardingState } from "./rootSelectors";

export const getIdXboxProgramState = (state: OnboardingRootState): IdXboxProgramState =>
  getOnboardingState(state)?.idXboxProgram ?? initialIdXboxProgramState;

export const getIdXboxProgramData = (
  state: OnboardingRootState
): IdXboxProgramDataResponse | null => getIdXboxProgramState(state).data;

export const getIdXboxProgramIsLoading = (state: OnboardingRootState): boolean =>
  getIdXboxProgramState(state).isLoading;

export const getIdXboxProgramError = (state: OnboardingRootState): string | null =>
  getIdXboxProgramState(state).error;

export const getIdXboxProgramCountriesOrRegions = (
  state: OnboardingRootState
): Array<FieldOption> =>
  getIdXboxProgramData(state)?.countriesOrRegions.map(country => ({
    id: country.id,
    value: country.label,
  })) ?? [];
